import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const k = sessionStorage.getItem("cor_admin_key");
  if (k) cfg.headers["X-Admin-Key"] = k;
  return cfg;
});

export const verifyAdmin = (key) => api.post("/admin/verify", { key }).then((r) => r.data);
export const setAdminKey = (k) => sessionStorage.setItem("cor_admin_key", k);
export const hasAdminKey = () => !!sessionStorage.getItem("cor_admin_key");

export const fetchStats = () => api.get("/stats").then((r) => r.data);
export const joinWaitlist = (email) => api.post("/waitlist", { email }).then((r) => r.data);
export const submitContact = (body) => api.post("/contact", body).then((r) => r.data);
export const fetchCompanyIndex = () => api.get("/company-index").then((r) => r.data);
export const fetchLeaderboard = (limit = 8, dimension = "customer") => api.get(`/leaderboard?limit=${limit}&dimension=${dimension}`).then((r) => r.data);
export const searchCompanies = (q) => api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => r.data);
export const fetchScreener = (params) => api.get("/screener", { params }).then((r) => r.data);
export const fetchSectors = () => api.get("/sectors").then((r) => r.data);
export const fetchRecentAlerts = () => api.get("/recent-alerts").then((r) => r.data);
export const fetchSectorList = () => api.get("/sector-list").then((r) => r.data);
export const fetchCompany = (ticker) => api.get(`/company/${ticker}`).then((r) => r.data);
export const auditCompanyDim = (ticker, dim, fresh = false) =>
  api.post(`/company/${ticker}/audit/${dim}${fresh ? "?fresh=true" : ""}`).then((r) => r.data);
export const refreshEdgar = () => api.post("/refresh-edgar?limit=6").then((r) => r.data);
export const startBackfill = (limit = 503, years = 3) => api.post(`/backfill/sp500?limit=${limit}&years=${years}`).then((r) => r.data);
export const backfillStatus = () => api.get("/backfill/status").then((r) => r.data);
export const fetchDisclosures = (ticker) => api.get(`/company/${ticker}/disclosures`).then((r) => r.data);
export const fetchSourceDoc = (ticker, dim) => api.get(`/company/${ticker}/filing-view/${dim}`).then((r) => r.data);
export const fetchMajorCustomers = () => api.get("/major-customers").then((r) => r.data);

export const startAudit = (limit = 100, dims = "") =>
  api.post(`/audit/run?limit=${limit}${dims ? `&dims=${dims}` : ""}`).then((r) => r.data);
export const auditStatus = () => api.get("/audit/status").then((r) => r.data);
export const accuracySlo = () => api.get("/accuracy/slo").then((r) => r.data);
export const adminSignups = () => api.get("/admin/signups").then((r) => r.data);
export const auditResults = (filter = "all", limit = 400) =>
  api.get(`/audit/results?filter=${filter}&limit=${limit}`).then((r) => r.data);
export const startDeepAudit = (threshold = 0.98) =>
  api.post(`/audit/deep?threshold=${threshold}`).then((r) => r.data);
export const deepAuditStatus = () => api.get("/audit/deep/status").then((r) => r.data);
export const coherenceScan = () => api.get("/audit/coherence").then((r) => r.data);
export const coherenceFix = () => api.post("/audit/coherence/fix").then((r) => r.data);

export const listAlerts = () => api.get("/alerts").then((r) => r.data);
export const createAlert = (body) => api.post("/alerts", body).then((r) => r.data);
export const deleteAlert = (id) => api.delete(`/alerts/${id}`).then((r) => r.data);

export const createCheckout = (package_id) =>
  api.post("/checkout/session", { package_id, origin_url: window.location.origin }).then((r) => r.data);
export const checkoutStatus = (sid) => api.get(`/checkout/status/${sid}`).then((r) => r.data);

// ---------- Custom auth (magic link + Google OAuth) ----------
// Every request carries the current window.origin so the backend can build a matching
// redirect_uri without trusting proxy-rewritten headers.
export const sendMagicLink = (email) =>
  api.post("/auth/magic-link", { email, origin: window.location.origin }).then((r) => r.data);
export const verifyMagicLink = (token) =>
  api.post("/auth/magic-link/verify", { token }).then((r) => r.data);
export const startGoogleOAuth = () =>
  api.post("/auth/google/start", { origin: window.location.origin }).then((r) => r.data);
export const completeGoogleOAuth = (code, state) =>
  api.post("/auth/google/callback", { code, state }).then((r) => r.data);
